import { Clock, MessageSquare, Shield, CheckCircle, Users, Phone } from 'lucide-react';

export function Features() {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-violet-50/30" id="features">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="flex flex-col lg:flex-row lg:items-start lg:gap-16">
          <div className="lg:w-[38%] mb-12 lg:mb-0">
            <span className="text-sm font-semibold tracking-widest text-violet-600 uppercase mb-3 block">
              Ventajas
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-5 leading-tight">
              ¿Por qué elegir{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-violet-600 to-purple-600">
                Abogalia?
              </span>
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              La forma más inteligente y segura de encontrar representación legal en Argentina.
            </p>
          </div>
          <div className="lg:w-[62%] grid sm:grid-cols-2 gap-x-8 gap-y-8">
            <div className="space-y-2">
              <div className="w-10 h-10 rounded-lg bg-violet-100 flex items-center justify-center">
                <Shield className="w-5 h-5 text-violet-600" />
              </div>
              <div className="font-semibold text-gray-900">Abogados Verificados</div>
              <div className="text-sm text-gray-600">
                Todos nuestros profesionales están matriculados y verificados por el Colegio de Abogados correspondiente.
              </div>
            </div>
            <div className="space-y-2">
              <div className="w-10 h-10 rounded-lg bg-green-100 flex items-center justify-center">
                <CheckCircle className="w-5 h-5 text-green-600" />
              </div>
              <div className="font-semibold text-gray-900">Sin Comisiones</div>
              <div className="text-sm text-gray-600">
                Conectamos abogados y clientes sin cobrar comisiones. Pagás directamente al profesional.
              </div>
            </div>
            <div className="space-y-2">
              <div className="w-10 h-10 rounded-lg bg-purple-100 flex items-center justify-center">
                <Users className="w-5 h-5 text-purple-600" />
              </div>
              <div className="font-semibold text-gray-900">Match Perfecto</div>
              <div className="text-sm text-gray-600">
                Nuestra IA conecta tu caso con abogados especializados en tu área legal específica.
              </div>
            </div>
            <div className="space-y-2">
              <div className="w-10 h-10 rounded-lg bg-green-100 flex items-center justify-center">
                <MessageSquare className="w-5 h-5 text-green-600" />
              </div>
              <div className="font-semibold text-gray-900">WhatsApp Directo</div>
              <div className="text-sm text-gray-600">
                Comunicación directa con tu abogado por WhatsApp, sin intermediarios ni demoras.
              </div>
            </div>
            <div className="space-y-2">
              <div className="w-10 h-10 rounded-lg bg-orange-100 flex items-center justify-center">
                <Clock className="w-5 h-5 text-orange-600" />
              </div>
              <div className="font-semibold text-gray-900">Tiempo Ahorrado</div>
              <div className="text-sm text-gray-600">
                Contá tu caso solo una vez, y recibí varias propuestas en simultáneo.
              </div>
            </div>
            <div className="space-y-2">
              <div className="w-10 h-10 rounded-lg bg-violet-100 flex items-center justify-center">
                <Phone className="w-5 h-5 text-violet-600" />
              </div>
              <div className="font-semibold text-gray-900">Soporte 24/7</div>
              <div className="text-sm text-gray-600">
                Nuestro equipo está disponible para ayudarte en cualquier momento del proceso.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}